module.exports = __webpack_public_path__ + "img/ssl_icon.64ce89a5.svg";